exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.gdpr-names h1 {\n  font-size: 24px;\n}\n", "", {"version":3,"sources":["/Users/Razvan/Documents/projects/archii/website-new/apps/account/Names.vue"],"names":[],"mappings":";AAAA;EACE,gBAAgB;CAAE","file":"Names.vue","sourcesContent":[".gdpr-names h1 {\n  font-size: 24px; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fd2e577","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./apps/account/Names.vue
// module id = 482
// module chunks = 0